<template>
  <div>
    <GameTitle />
    <div class='container'>
      <div class='content'>
        <h2>Dots And Boxes</h2>
        <p>Dots game (French: <a href='https://fr.wikipedia.org/wiki/La_Pipopipette' target='_blank'>La Pipopipette</a>, Malayalam: <a href='https://ml.wikipedia.org/wiki/%E0%B4%AA%E0%B5%82%E0%B4%9C%E0%B5%8D%E0%B4%AF%E0%B4%82_%E0%B4%B5%E0%B5%86%E0%B4%9F%E0%B5%8D%E0%B4%9F%E0%B5%8D'>പൂജ്യം വെട്ട്</a>) is a game played using a pencil and a paper. Players take turns adding a single horizontal or vertical line between two unjoined adjacent dots. A player who completes the fourth side of a 1×1 box earns one point and takes another turn. The player who makes the most number of boxes win. [<a href='https://en.wikipedia.org/wiki/Dots_and_Boxes' target='_blank'>Wikipedia</a>]</p>
        <h3>FAQ</h3>
        <ul>
          <li>How many players can play ?</li>
          <p>There is <b>no limit</b> for the number of players who can join the game. If every player has a good internet connection, then it will work out fine. We recommend a max of 10 players</p>
          <li>I can't join the game!</li>
          <p>There are some unknown issues with some routers and internet service providers for making P2P connections to other players. Try changing your internet connection or browser or system</p>
          <li>What's P2P ?</li>
          <p>Instead of a server managing the game and players, Vett uses Peer To Peer connections to run the game. This means you and your playmates connect to each other directly forming a mesh network and play together. Servers have very little role in this setup.</p>
          <li>Privacy</li>
          <p>No personal information about you, or identifiable information about you is shared with anyone. Only the name you type in will be shared to other players in the game.</p>
          <li>Why the name "Vett" ?</li>
          <p>The game is called "Poojyam <b>Vett</b>" in the language Malayalam.</p>
          <li>What if the game gets interrupted and user reloads?</li>
          <p>The other player(s) will send the game state to this user and help restoring the game</p>
        </ul>
        <div class='has-text-centered'>
          Made by&nbsp;<a href='https://twitter.com/SubinSiby'>Subin Siby</a>&nbsp;and&nbsp;<a href='https://github.com/athul'>Athul Cyriac Ajay</a><br/>
          <a href='https://github.com/subins2000/vett'>Source Code </a>&nbsp;
          <br/><br/>
          <a href='https://subinsb.com/donate' target='_blank' class='button is-medium is-success'>Help Sustain This Game : Donate</a>
        </div><br/><br/>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'About'
}
</script>
